import { useSelector } from "react-redux";
import { RootState } from "../../redux/Store/store";
import { useId } from "react";
import { ScoreSection } from ".";
import { LuArrowUpFromLine } from "react-icons/lu";
const FinalScoreCard = ({
  togglePanel,
  openPanels,
}: {
  togglePanel: (panel: string) => void;
  openPanels: any;
}) => {
  const finalScoreId = useId();

  const { completedTestData } = useSelector(
    (state: RootState) => state.root.startFullTest
  );

  const questionData = completedTestData?.additionalProps?.overallresult;
  const {
    overallReadingScaledScore,
    overallMathScaledScore,
    overallFinaleScaledScore,
  } = questionData || {};

  const finalScores: ScoreSection = {
    title: "Final Score",
    totalScore: `${overallFinaleScaledScore || "0"} / 1600`,
    modules: [
      {
        name: "Reading & Writing",
        score: overallReadingScaledScore,
        total: "800",
      },
      { name: "Math", score: overallMathScaledScore, total: "800" },
    ],
  };

  return (
    <div
      className={`rounded-[28px] p-3 border-[0.5px] border-satPrepGrey bg-satPrepTransWhite shadow-widget-card backdrop-blur-sevenFive basis-[50%] flex-grow ${
        openPanels?.finalScore ? "h-full" : "h-fit"
      }`}
    >
      <div
        className={`${
          openPanels?.finalScore ? "border-b border-satPrepGrey" : ""
        } flex items-center justify-between text-appPrimaryColor text-xl transition-all duration-300 ease-in-out`}
      >
        <div className="flex items-center p-3 gap-[10px] font-gully text-satPrepDarkAccent font-medium text-xl">
          <button
            onClick={() => togglePanel("finalScore")}
            className=" hover:bg-gray-100 rounded"
          >
            <LuArrowUpFromLine size={22} className="mb-1"/>
          </button>
          <span className="font-medium">Final Score</span>
        </div>
        <span className="text-satPrepDarkAccent font-medium">
          {completedTestData?.isCustomTest ? "-" : finalScores.totalScore}
        </span>
      </div>
      {openPanels?.finalScore && (
        <div>
          {finalScores.modules.map((module: any, idx: number) => (
            <div
              key={finalScoreId}
              className="flex justify-between font-gully text-satPrepXDarkAccent font-medium items-center text-base"
            >
              <span className="px-3 py-[6px]">{module.name}</span>
              {completedTestData?.isCustomTest ? (
                <span> - </span>
              ) : (
                <span>
                  {module.score || "0"} / {module.total}
                </span>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default FinalScoreCard;
